<template>
  <div class="explanation">
    <!--<h4>{{placeholder}}</h4>-->
    <v-textarea
      class="free-response pp-interaction-feedback"
      error-messages
      :label="placeholder"
      v-model="interactionAttempt.explanation"
      :disabled="interactionMeta.isExplanationSubmitted || interactionMeta.isProcessingData"
      :rules="explanationRules"
      maxlength="500"
      rows="2"
    ></v-textarea>
  </div>
</template>

<script>
/* global _ */
export default {
  name: 'interaction-explanation',
  props: [
    'interactionId',
  ],
  data() {
    return {
      explanationRules: [
        v => ((v && v.length < 500) || !v)|| "Text cannot be longer than 500 characters."
      ],
    }
  },
  computed: {
    aria() {
      return {
        label: `Interaction explanation`
      }
    },
    interaction() {
      return this.$store.getters['interactions/interaction'](this.interactionId) || {};
    },
    interactionAttempt() {
      return this.$store.getters['interactions/interactionAttempt'](this.interactionId) || {};
    },
    interactionMeta() {
      return this.$store.getters['interactions/interactionMeta'](this.interactionId) || {};
    },
    placeholder() {
      if (this.interactionMeta.rubric) return 'Comments/Explanation:';
      return 'Explain your answer below.';
    }
  },
};
</script>

<style>
  .pp-interaction-feedback .v-input, .pp-interaction-feedback .v-label{
    font-size: inherit;
  }
</style>
